import script from "./OurServiceDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./OurServiceDetail.vue?vue&type=script&setup=true&lang=js"

import "./OurServiceDetail.vue?vue&type=style&index=0&id=5bc4be21&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bc4be21"]])

export default __exports__